/**
 * Schermteksten in het Italiaans.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const it: Teksten = {
  kamerOphalen: "Recupero camera…",
  kamerWerktNiet: "Questa camera non funziona",
  serverReageertNiet: "Il server non risponde",
  probeerOpnieuw: "Riprova",
  vraagNieuweCode: "Chiedi una nuova codice a chi l'ha condivisa. Una camera scade dopo poche ore.",
  welkeTaalSprekJij: "Che lingua parli?",
  jouwStem: "La tua voce nella traduzione",
  man: "Uomo",
  vrouw: "Donna",
  pincode: "Codice PIN",
  pincodeUitleg: "Ti viene fornito da chi ha condiviso il codice.",
  gaDeKamerIn: "Entra nella camera",
  kiesEerstJeTaal: "Scegli prima la tua lingua",
  microfoonAanvragen: "Richiesta microfono…",
  toestemmingUitleg: "Il tuo browser ti chiederà l'autorizzazione per il microfono. Senza di essa potrai solo digitare.",
  microfoonTestLink: "Prova prima il microfono",
  stemGaatMee: "In questa camera l'altro sentirà anche la tua voce originale, oltre alla traduzione.",
  alleenChatMelding: "Questa conversazione è solo chat. Scrivi i tuoi messaggi e leggi la traduzione; niente viene letto ad alta voce.",
  verlooptOm: "Scade alle",
  nooitVasteKamer: "Mai, stanza fissa",
  kamer: "Camera",
  tolkgesprek: "Conversazione interpretata",
  juisteKamer: "Sei nella camera giusta. Tra poco potrai parlare qui.",
  jij: "tu",
  deAnder: "l'altro",
  verbinden: "Connessione…",
  verbonden: "Connesso",
  verbindingKwijt: "Connessione persa. Riprovo…",
  wachtenOpAnder: "Sei dentro. Attendi che l'altro esegua la scansione del codice QR.",
  allebeiInDeKamer: "Siete entrambi nella camera.",
  anderIsWeg: "L'altro se n'è andato",
  anderSpreekt: "L'altro sta parlando…",
  jeKuntErNietIn: "Impossibile accedere",
  overgenomenTitel: "Continuato su un altro dispositivo",
  overgenomenUitleg: "Questa conversazione è stata appena aperta su un altro dispositivo. Continua a parlare lì.",
  terug: "Indietro",
  geluidStaatUit: "L'audio è disattivato. Tocca un punto qualsiasi dello schermo.",
  tikHier: "tocca qui",
  bewaardTot: 'Conservato fino alle {tijd}',
  bewaardVast: "Stanza fissa. I messaggi restano salvati per 30 giorni.",
  spreekIn: "Parla",
  luisteren: "Ascolto… tocca per fermare",
  uitschrijven: "Trascrizione…",
  tijdOmTeVerbeteren: "Tempo per correggere",
  altijdZelfVersturen: "Controlla e invia sempre manualmente",
  jijVerstuurtZelf: "Invio manuale",
  uit: "disattivo",
  sec: "sec",
  vertalingMeteenAfspelen: "Riproduci subito la traduzione",
  typHierJeBericht: "Scrivi qui il tuo messaggio…",
  stuur: "Invia",
  geenOpnameMogelijk: "Questo browser non può registrare audio. Puoi comunque digitare.",
  verstaanAls: "Capito come",
  tellerStaatStil: "il timer è fermo",
  versturen: "Invia",
  wis: "Cancella",
  jijZei: "hai detto",
  vertaald: "tradotto",
  duimOmhoog: "È corretto",
  duimOmlaag: "Non è corretto",
  opnieuwProberenKnop: "Riprova con un modello migliore",
  opnieuwProberenBezig: "Ritraduzione in corso…",
  duimTranscriptWoordenlijstUitnodiging: "Capito male? Correggi nel glossario:",
  instellingenAanpassen: "Modifica impostazioni",
  geldtVoorJullieBeiden: "Vale per entrambi",
  alleenVoorJou: "Solo per te",
  stuurMijnStemMee: "Invia la mia voce originale",
  verbeterSpelfouten: "Correggi gli errori ortografici nel mio testo",
  verbeterSpelfoutenUit: "Disattivando questa opzione vedrai esattamente ciò che è stato capito, errori inclusi.",
  alleenChat: "Solo chat: niente voce, niente microfono",
  alleenChatUitleg: "Scrivete entrambi. Vengono mostrati la traduzione e il testo originale; niente viene letto ad alta voce.",
  aangepastDoorDeAnder: "L'altro ha modificato le impostazioni.",
  foutSpraak: "La traduzione è presente, ma non è stato riprodotto l'audio.",
  foutSpraakQuota: "Il limite vocale per oggi è esaurito. Il testo funziona normalmente; la voce tornerà domani.",
  foutBudgetKamer: "Questa conversazione ha raggiunto il suo limite, quindi la traduzione è in pausa. Chi l’ha creata può aumentarlo; poi funziona subito di nuovo.",
  foutBudgetMaand: "Il budget mensile dell’app è esaurito. La traduzione tornerà a funzionare quando l’amministratore lo modificherà.",
  foutTaal: "Questa lingua non è disponibile: parlereste entrambi la stessa lingua.",
  origineel: "originale",
  vertalen: "Traduzione…",
  vertalenMislukt: "Traduzione non riuscita.",
  opnieuwAfspelen: "Riproduci di nuovo la traduzione",
  hoorDeAnder: "Ascolta com'è stato detto in originale",
  woordenlijst: "Glossario di sicurezza",
  woordenlijstUitleg: "L'app capisce sempre male un nome o un termine tecnico? Definisci qui il significato corretto.",
  hijHoort: "sente…",
  jijBedoelt: "intendi…",
  ookVolgendeGesprekken: "Anche nelle prossime conversazioni — altrimenti vale solo per questa",
  voegToe: "Aggiungi",
  bezig: "In corso…",
  lijstNietGeladen: "Impossibile caricare la lista.",
  toevoegenMislukt: "Aggiunta non riuscita.",
  verwijderenMislukt: "Eliminazione non riuscita.",
  overal: "ovunque",
  verwijder: "Elimina",
  overDitGesprek: "Su questa conversazione",
  toon: "Tono della traduzione",
  sfeer: "Atmosfera della conversazione",
  jouwPlek: "La tua posizione",
  hoeHetWerkt: "Il server trascrive la tua registrazione e la traduce all'istante. La tua voce originale viene inviata all'altro.",
  kleinereTekst: "Testo più piccolo",
  grotereTekst: "Testo più grande",
  insprekenVerbergen: "Nascondi microfono",
  insprekenTonen: "Mostra microfono",
  toetsenbordVerbergen: "Nascondi tastiera",
  toetsenbordTonen: "Mostra tastiera",
  vormAutomatisch: "Automatico",
  vormInformeel: "Informale (tu)",
  vormFormeel: "Formale (Lei)",
  sfeerNeutraal: "Neutrale",
  sfeerZakelijk: "Professionale",
  sfeerOfficieel: "Ufficiale",
  sfeerVriendschappelijk: "Amichevole",
  sfeerPartner: "Partner",
  foutKamerVol: "Questa camera è piena. Possono entrare solo due persone.",
  plekBezetTitel: "Il tuo posto è occupato",
  plekBezetUitleg: "Qualcuno occupa già il tuo lato di questa conversazione, nella tua lingua. Di solito sei tu: la conversazione è ancora aperta su un altro dispositivo o in un'altra scheda. Chiudila lì e riprova. A volte ci vuole un minuto e mezzo prima che il posto si liberi.",
  plekBezetWissel: "Sei tu? Scrivi WISSEL per portare la conversazione su questo dispositivo. L'altro dispositivo si chiuderà.",
  plekBezetKnop: "Porta su questo dispositivo",
  foutKamerVerlopen: "Questa camera è scaduta o è stata chiusa.",
  foutKamerOnbekend: "Questa camera non esiste.",
  foutPinNodig: "Questa camera richiede un codice PIN.",
  foutPinFout: "Il codice PIN non è corretto.",
  foutProtocol: "L'app e il server non si capiscono. Aggiorna la pagina.",
  foutMicroGeweigerd: "Hai negato l'accesso al microfono. Clicca sul lucchetto nella barra degli indirizzi e attivalo.",
  foutGeenMicro: "Nessun microfono trovato. Connettine uno e riprova.",
  foutMicroInGebruik: "Il microfono è utilizzato da un altro programma. Chiudilo e riprova.",
  foutGeenHttps: "Il microfono funziona solo su una connessione sicura. Apri questa pagina tramite https.",
  foutMicroOnbekend: "Impossibile avviare il microfono.",
  foutNietsOpgenomen: "Non è stato registrato nulla. Il microfono è acceso?",
  foutNietsGehoord: "Nessun suono rilevato. Il microfono è acceso e parli a voce abbastanza alta?",
  foutOpnameTeLang: "La registrazione è troppo lunga. Parla a intervalli più brevi.",
  foutMicroGedempt: "Il tuo microfono è disattivato. Attivalo e riprova.",

  // --- microfoontest ---
  micTitel: "Test del microfono",
  micOnderschrift: "Quattro test di seguito, cinque secondi ciascuno. Continua a parlare per tutto il tempo.",
  micStart: "Avvia il test",
  micTest1: "1. Solo riconoscimento",
  micTest2: "2. Solo registrazione",
  micTest3: "3. Insieme — prima la registrazione",
  micTest4: "4. Insieme — prima il riconoscimento",
  micFase1: "1 di 4: solo riconoscimento — di' una frase breve",
  micFase2: "2 di 4: solo registrazione — continua a parlare",
  micFase3: "3 di 4: prima la registrazione, poi il riconoscimento — continua a parlare",
  micFase4: "4 di 4: prima il riconoscimento, poi la registrazione — continua a parlare",
  micKlaar: "fatto",
  micGehoord: "sentito",
  micOpnameformaat: "Formato di registrazione",
  micGeen: "nessuno",
  micBeveiligd: "Connessione sicura",
  micJa: "sì",
  micNee: "NO",
  micBrowser: "Browser",
  micGeenHttps: "Senza https il browser non libera il microfono. Su localhost è consentito.",
  micGeenHerkenning: "Questo browser non ha il riconoscimento vocale.",
  micZegIets: "di' qualcosa…",
  micWoordenBinnen: "arrivano parole",
  micKonNietStarten: "non è riuscito ad avviarsi",
  micGeenRecorder: "Questo browser non conosce MediaRecorder.",
  micOpnemen: "registrazione…",
  micNietsOpgenomen: "niente registrato",
  micGeenMicrofoon: "nessun microfono",
  micOpnameEerst: "prima la registrazione…",
  micHerkenningEerst: "prima il riconoscimento…",
  micOpnameStarttNiet: "la registrazione non è partita",
  micSamenGelukt: "Insieme. Registrazione {kb} kB.",
  micAlleenOpname: "Registrazione sì, riconoscimento no.",
  micAlleenHerkenning: "Riconoscimento sì, registrazione no.",
  micGeenVanBeide: "Nessuno dei due.",
  micNetwerkFout: "Il riconoscimento vocale non è riuscito a raggiungere il server.",
  micAfgebroken: "La registrazione è stata interrotta.",
  verslagTitel: "Resoconto della conversazione",
  verslagWie: "Chi",
  verslagOrigineel: "Originale",
  verslagVertaling: "Traduzione",
  verslagSpreker: "Interlocutore {x}",
  verslagBerichten: "Messaggi",
  verslagGemaaktOp: "Creato il",
  verslagGeenOpname: "Non è una registrazione letterale.",
  verslagNootOrigineel: "«Originale» è il testo come l’app ha capito chi parlava.",
  verslagNootCorrectie: "La correzione ortografica era attiva: i piccoli errori di battitura sono stati corretti.",
  verslagNootAangepast: "Chi ha parlato poteva ancora modificare il testo prima dell’invio.",
  verslagGesproken: "parlato",
  verslagGetypt: "digitato",
  verslagMislukt: "Traduzione non riuscita. L’altra persona non ha visto questa frase nella propria lingua.",
  verslagNietKlaar: "La traduzione non era ancora pronta quando è stato creato questo resoconto.",
  verslagVertrouwelijk: "Riservato.",
  verslagAlleenDeelnemers: "Questo resoconto contiene il contenuto di una conversazione privata ed è destinato solo ai partecipanti.",
  verslagGewist: "Data di eliminazione della conversazione: {tijd}. Dopo, questo resoconto non potrà essere ricreato.",
  verslagGewistVast: "Stanza fissa: ogni messaggio viene eliminato 30 giorni dopo l'invio. I messaggi più vecchi non compaiono in questo verbale.",
};
